import {NavLinksGroupSlice} from 'prismicio-types'
import {memo} from 'react'
import {Context} from 'src/common/types'
import {NavLinksGroupDefault} from './Default'
import {NavLinksGroupVariationV2} from './VariationV2'

type NavLinksGroupProps = {
  context: Context
  slice: NavLinksGroupSlice
  index: number
}

const NavLinksGroup = ({context, slice, index: componentIndex}: NavLinksGroupProps) => {
  switch (slice.variation) {
    case 'v2':
      return <NavLinksGroupVariationV2 context={context} slice={slice} index={componentIndex} />
    case 'default':
      return <NavLinksGroupDefault context={context} slice={slice} index={componentIndex} />
    default:
      return null
  }
}

export default memo(NavLinksGroup)
